import { PersonalPricePlanStep, messageData } from './constant';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ProviderManager from 'app/provider/providerManager';
import {Onboarding} from 'app/Components/Page/SelfCarePage/SelfCareAsyncThunk';
import SubscriptionInformation from '../TvActivationCodeRecoveryBlock/SubscriptionInformation';
import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';
import { DisplayNameOrNumber } from './constant';
import {createOtpLoginStep1 ,createOtpLoginStep02} from 'app/utilities/authentication/authenticationSlice';
import {dwhReportBuilder , reportsDictionary} from './reportDwh';
import {rolesKeys} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import {refreshToken} from 'app/utilities/authentication/authenticationSlice';
const initialState = {
  loading: false,
  error: false,
  processedSubscriberNo:'',
  currentStep: PersonalPricePlanStep.Initial,
  messageData:null,
  selectedBan: null,
  subscribersList: [],
  selectedSubscribers: [],
  selectedPackage: null,
  recommendations: [],
  changeAuthFinished: false,
  isFetchedPersonalizedPricePlans: false,
  productsByBan: [],
  showPopup: false,
};


export const getProductsById = createAsyncThunk('personalPricePlan/getProductsById', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('GetProductsById', [data.idNumber]);
    return {data: result.Body};
  } catch (error) {
    return {data: {isSuccess: false}};
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getPersonalizedPricePlans = createAsyncThunk('personalPricePlan/getPersonalizedPricePlans', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getPersonalizedPricePlans', [data.ban]);
    return {data: result.Body};
  } catch (error) {
    return {data: {isSuccess: false}};
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const fetchPricePlanMetadata = createAsyncThunk('personalPricePlan/fetchPricePlanMetadata', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('fetchPricePlanMetadata', [data.offerId , data.ban]);
    return {data: result.Body};
  } catch (error) {
    return {data: {isSuccess: false}};
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const updatePricePlan = createAsyncThunk('personalPricePlan/UpdatePricePlan', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().personalPricePlan;
    const request = {
      Ban: state.selectedBan,
      Subscribers: state.selectedSubscribers.map((subscriberNo) => {
        const subscriber = state.subscribersList.find((s) => s.subscriberNo === subscriberNo);
        const commCode = state.recommendations?.[state.selectedPackage.pricePlanCode]?.find((r) => r.subscriber === subscriberNo)?.commCode || '';
        return {
          SubscriberNumber: subscriberNo,
          AssetExternalId: subscriber?.assetExternalId ?? '',
          Comm_Code: commCode,
        };
      }),
      ProcessedSubscriber: state.processedSubscriberNo,
      OfferId: state.selectedPackage.offerID,
      IsImmiediatePP: state.selectedPackage?.pricePlanMetadata?.isImmediatePlan ?? false,
    }
    const result = await ProviderManager.getProviderData('UpdatePricePlan', request);
    if (result.Body.isSuccess) {
      await thunkAPI.dispatch(refreshToken());
    }
    return {data: result.Body};
  } catch (error) {
    return {serverError: true};
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getBanProductsDescription = createAsyncThunk('personalPricePlan/getBanProductsDescription', async (data, thunkAPI) => {
  try {
    var request = {
      ban: data.ban,
    }
    const result = await ProviderManager.getProviderData('getBanProductsDescription', request);
    return {data: result.Body};
  } catch (error) {
    return {serverError: true};
  }
});

const personalPricePlanBlockSlice = createSlice({
  name: 'personalPricePlan',

  initialState: initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setMessageData: (state, action) => {
      state.messageData = action.payload;
      if(!action.payload.isPopup){
        state.currentStep = PersonalPricePlanStep.GeneralMessage;
      }else{
        state.showPopup= true;
      }
      return state;
    },
    setShowPopup: (state, action) => {
      state.showPopup = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSelectedBan: (state, action) => {
      state.selectedBan = action.payload;

      state.subscribersList = state.productsByBan.find((b) => b.ban == action.payload)?.products || [];
      if(state.subscribersList.length == 1){
        state.selectedSubscribers = [state.subscribersList[0].subscriberNo];
      }else{
        state.selectedSubscribers =[];
      }
    },
    saveToHistory: (state, action) => {
      return state;
    },
    pushToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return initialState;
    },
    backHistory: (state, action) => {
      return state;
    },
    setSelectedSubscribers: (state, action) => {
      state.selectedSubscribers= action.payload;
      return state;
    },
    setSubscribersList: (state, action) => {
      state.subscribersList = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setProcessedSubscriberNo: (state, action) => {
      state.processedSubscriberNo = action.payload;
    },
    updateSubscribersList: (state, action) => {
      let subsciberToUpdate = action.payload.subscriberNo;
      let fieldToUpdate = action.payload.field;
      let valueToUpdate = action.payload.value;
      state.subscribersList.forEach((subscriber) => {
        if(subscriber.subscriberNo === subsciberToUpdate){
          subscriber[fieldToUpdate] = valueToUpdate;
        }
      });
    },

  },


  extraReducers: {
    [getPersonalizedPricePlans.fulfilled]: (state, action) => {
      var res = action.payload.data;
      if(res.isSuccess){
        state.isFetchedPersonalizedPricePlans = true;
        state.recommendations = res.recommendations;
        state.recommendationsPPCode = res.recommendations ? Object.keys(res.recommendations) : [];
      }
      else{
        return errorHandler(state);
      }
      return state;
    },
    [fetchPricePlanMetadata.fulfilled]: (state, action) => {
      var res = action.payload.data;

      var productsByelectdBan = state.productsByBan.find((b) => b.ban == state.selectedBan);

      if(res?.isSuccess){
        state.selectedPackage = { 
          ...state.selectedPackage,
         pricePlanMetadata: {
              minimumSubscriberForDiscount :res.minimumSubsForDiscount,
              effectiveDate:productsByelectdBan.products[0].billCycle || null,
              priceByPeriodByNumOfSub: {...res.priceByPeriodByNumOfSub},
              transitPrice: res.transitPrice || null,
              isImmediatePlan: res.hasImmediatePPChangeIndicator || null,
              isBRB: res.is_BRB_PP || null,
            
        } };
      }
      else{
        return errorHandler(state);
      }
      return state;
    },
    // [Onboarding.fulfilled]: (state, action) => {
    //   if(state.subscribersList.length == 0){
    //     state.subscribersList = action.payload.subscribersByProduct[TAB_ENUM.Cellular] || [];
    //   }
    //   return state;
    // },
    [getProductsById.fulfilled]: (state, action) => {
      var res = action.payload.data;
      if(res?.isSuccess){
        if(res?.productsByBan){
           state.productsByBan = res.productsByBan;
        }
        else{
          return errorHandler(state);
        }
      }
      return state;
    },
    [updatePricePlan.fulfilled]: (state, action) => {
      var res = action.payload.data;
      if(res?.isSuccess){
        state.currentStep = PersonalPricePlanStep.SuccessPage;
      }
      else{
        return errorHandler(state);
      }
      return state;
    },
    [createOtpLoginStep1.fulfilled]: (state, action) => {
      if(action.meta.arg.isExtended && state.currentStep == PersonalPricePlanStep.SelectPackage){
        //dwhReportBuilder(reportsDictionary.POPUP_OTP_EXTENDED_ENTER_OTP);
      }
    },
    [createOtpLoginStep02.fulfilled]: (state, action) => {
     var loginType = action.meta.arg.loginType;
     if(loginType == rolesKeys.OTPEXTENDED  && state.currentStep == PersonalPricePlanStep.SelectPackage){
      //dwhReportBuilder(reportsDictionary.POPUP_OTP_EXTENDED_SUCCESS);
      state.currentStep = PersonalPricePlanStep.SelectSubscribers;
     }

    }

  }
});

const errorHandler = (state) => {
  state.messageData = messageData.ERROR;
  state.currentStep = PersonalPricePlanStep.GeneralMessage;
  return state;
}
export const { setLoading, setError , setCurrentStep, setMessageData  , setSelectedBan, saveToHistory, pushToHistory, clearHistory, backHistory, setSelectedPackage, setSelectedSubscribers, setSelectedPackag ,setProcessedSubscriberNo, updateSubscribersList, setSubscribersList, setShowPopup } = personalPricePlanBlockSlice.actions;
export default personalPricePlanBlockSlice.reducer;
